import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import { feeTypes } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

import { getValuesForInfoMessage } from './helpers'

const InfoFeeMessage = ({
  extraFeeType,
  baseFee,
  extraFee,
  includedItems,
  currency = 'EUR',
  isAdditionalExtraFeeActive,
  isAdditionalFee,
}) => {
  const { t, i18n } = useTranslation()

  const getExtraFeeMessage = valuesForAlertMessage => {
    if (extraFeeType === feeTypes.flatFee && isAdditionalExtraFeeActive) {
      return t('En la primera transacción se cobrarán {{extraFee}}', valuesForAlertMessage)
    } else if (extraFeeType === feeTypes.perReturnedItem) {
      if (valuesForAlertMessage.includedItems > 1) {
        return t(
          'En la primera transacción se cobrarán {{baseExtraFee}} por los {{includedItems}} primeros productos devueltos y {{extraFee}} por cada producto adicional',
          valuesForAlertMessage
        )
      } else {
        return t(
          'En la primera transacción se cobrarán {{baseExtraFee}} por el primer producto devuelto y {{extraFee}} por cada producto adicional',
          valuesForAlertMessage
        )
      }
    }
  }

  const getExtraFeeAdditionalTransactionMessage = valuesForAlertMessage => {
    if (extraFeeType === feeTypes.flatFee) {
      return t('En las siguientes transacciones se cobrarán {{extraFee}}', valuesForAlertMessage)
    } else if (extraFeeType === feeTypes.perReturnedItem) {
      if (valuesForAlertMessage.includedItems > 1) {
        return t(
          'En las siguientes transacciones se cobrarán {{baseExtraFee}} por los {{includedItems}} primeros productos devueltos y {{extraFee}} por cada producto adicional',
          valuesForAlertMessage
        )
      } else {
        return t(
          'En las siguientes transacciones se cobrarán {{baseExtraFee}} por el primer producto devuelto y {{extraFee}} por cada producto adicional',
          valuesForAlertMessage
        )
      }
    }
  }

  const getMessage = () => {
    const valuesForInfoMessage = getValuesForInfoMessage({
      extraFee,
      includedItems,
      baseExtraFee: baseFee,
      currency,
      language: i18n.language,
    })

    if (isAdditionalFee) {
      return getExtraFeeAdditionalTransactionMessage(valuesForInfoMessage)
    }

    return getExtraFeeMessage(valuesForInfoMessage)
  }

  if (extraFeeType === feeTypes.flatFee && !isAdditionalExtraFeeActive) return null

  return <Alert type="info">{getMessage()}</Alert>
}

export default InfoFeeMessage
